import { render, staticRenderFns } from "./enableMFA.vue?vue&type=template&id=4abce8c2&scoped=true&"
import script from "./enableMFA.vue?vue&type=script&lang=js&"
export * from "./enableMFA.vue?vue&type=script&lang=js&"
import style0 from "./enableMFA.vue?vue&type=style&index=0&id=4abce8c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abce8c2",
  null
  
)

export default component.exports